<!--充值返利小组件-->
<template>
  <view class="rechargeRebate recharge-small-modal" v-if="showModal">
    <view class="close-btn" @click="close"></view>
    <a-button class="get-bonus-btn" @click="handleBouns">{{$t("claim")}}</a-button>
  </view>
</template>
<script setup>
import {ref,computed} from 'vue'
import eventEmitter from "@/utils/emitter.js";
import handleResponse from "@/utils/handleResponseData.js";
import $api from "@/api/index.js"
import $store from "@/store/index.js";
import { showRechargeRebateModal } from "@/utils/auth.js";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
//websocket info 类型 user_rebate_switch=0充值返利关闭  user_rebate_switch=1 充值返利开启
const userStore = $store("user");
const siteStore = $store("siteInfo")
/**
 * //TODO: 充值返利组件
 * 根据websocket info 类型 user_rebate_switch=0充值返利关闭  user_rebate_switch=1 充值返利开启
 * 怎么传值给组件
 *
 * 什么情况关闭组件
 *
 * 领取奖金按钮功能
 *
 *
 * 侧边栏充值返利组件
 *  当websocket info 类型 user_rebate_switch=0充值返利关闭  user_rebate_switch=1 充值返利开启
 *  叉掉 刷新或开启新窗口时 根据user_rebate_switch控制显隐
 *
 *  点击该组件按钮,弹框返利大弹框
 *
 *  登录成功时调用查看返利接口,is_use=y 弹返利大弹框
 *
 *  cookie closeRebate 缓存时间不超时10小时(控制侧边栏充值返利弹框)
 *
 */

const emits = defineEmits(['close'])
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})
const showModal = computed(() => {
  console.log('showmodal:',props.visible)
  console.log('showmodal:',!cookies.get("closeRebate"))
  return props.visible && !siteStore.closeRebate;
})
const u = $store("user");

//领取奖金
function handleBouns() {
  //TODO:领取奖金
  console.log('弹返利大弹框')
  if (u.isToken) {
    // eventEmitter.emit('api:showRechargeRebateModal',999)
    showRechargeRebateModal(userStore, $api, handleResponse,true);
  } else {
    console.log('弹登录框')
    eventEmitter.emit('api:un_auth')
  }
}


function close() {
  console.log("设置cookies")
  cookies.set("closeRebate", true, "10h")//缓存时间不超时10小时,设置后,10小时内侧边栏不会再显示充值返利弹框
  emits("close")
}
</script>


<style scoped lang="scss">
.rechargeRebate {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url('@/assets/images/event/rechargeRebate/smallModal.png');

  .close-btn {
    cursor: pointer;
    position: absolute;
    top: .05rem;
    right: .48rem;
    width: .14rem;
    height: .14rem;
    background-image: url('@/assets/images/systemicon/closegray.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }

  .get-bonus-btn {
    width: 1.5rem;
    height: .36rem;
    background: linear-gradient(0deg, #FFA914 0%, #CC6600 100%);
    border-radius: .05rem;
    position: absolute;
    left: 50%;
    bottom: 45%;
    transform: translateX(-50%);
    @extend %flex-all-center;
    font-weight: bold;
    font-size: .14rem;
    color: #FFFFFF;
  }
}

.recharge-small-modal {
  width: 2.63rem;
  height: 2.63rem;
  position: fixed;
  z-index: 3;
  top: 50%;
  right: 0;
}
</style>